import * as React from 'react';

import { Page, PageHeader } from '../components/common';
import Button from '../components/buttons/Button';

interface Props {
	actions: any;
	history: any;
}
class LandingFirstChildPage extends React.Component<Props, any> {
	render() {
		return (
			<Page>
				<PageHeader title="Life Insurance and your first child" />
				<div className="container">
					<div className="row">
						<div className="col-md-8 offset-md-2">
							<div className="section section-right section-secondary">
								<Button to="/quote" className="btn-primary">CTA to Quote Workflow</Button>
							</div>
						</div>
					</div>
				</div>
			</Page>
		);
	}
}
export default LandingFirstChildPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/landing/LandingFirstChildPage.tsx